import { componentConfig, componentLoader } from "../../lib/component_initializer";
import { StarRating } from "./star_rating";

export const starRatingLoader = function (options = {}) {
    componentLoader(componentConfig(StarRating, StarRating.config.componentTypeKey, StarRating.config.baseHtmlClass), options);
};
